var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:"form"},[_c('form',{staticClass:"row",style:(_vm.styles),attrs:{"id":_vm.fieldId}},[_vm._l((_vm.fields),function(field){return [_c('componentRenderer',{key:field.id,class:`col-lg-${field.properties.grid.columns}`,attrs:{"field":field},on:{"component-updated":_vm.updated}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }